import { goToHref } from "../components/global/GlobalTools";

/**
 * Validate error response from API service
 * @param {String} httpResponse
 */
export function validateErrorResponse(httpResponse) {
  const error = ErrorResponse(httpResponse);
  const prefix = localStorage.getItem("prefix");
  const tokenKey = `cmToken${prefix}`;

  if (!error) return;

  const isValidationError = error?.type === "validation";
  const isTokenInvalid = error?.code === "err_token_invalid";

  if (isValidationError || isTokenInvalid) {
    localStorage.removeItem(tokenKey);
    goToHref("/login");
  }
}

/**
 * Return error response from API service
 * @param {String} httpResponse
 */
export function ErrorResponse(httpResponse) {
  const data = httpResponse?.data;
  return data?.error || data || httpResponse;
}
